import { configureStore,applyMiddleware, getDefaultMiddleware } from "@reduxjs/toolkit";
import cartReducer from '../cartSlice'
import thunk from "redux-thunk";
import reduxLogger from "redux-logger";
import logger, { ReduxLoggerOptions, createLogger } from "redux-logger";
// import reducer from "../cartSlice";

    const logger1 = createLogger(reduxLogger.default)
      const middleware = [thunk]
    
    // export const Store =  configureStore({
    //     reducer: {

    //         cartSlice
    //     },
    //     middleware: middleware
    // })


    export const Store = configureStore({
        reducer:{
            cartReducer
        }, 
        middleware: middleware
    
    })